<template>
    <o-card :title="$t('sandoz.contracts_pdf_upload')">
        <o-pdf-upload-drop @document="documents"></o-pdf-upload-drop>

        <div class="table-responsive mt-4" v-if="documentList.length">
            <table class="table">
                <thead>
                <tr>
                    <th>{{$t('sandoz.contract_no')}}</th>
                    <th>{{$t('sandoz.file_name')}}</th>
                    <th>{{$t('sandoz.status')}}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(document, index) in documentList" :key="index">
                    <td>{{document.contract ? document.contract.contract_no : '-'}}</td>
                    <td>{{document.file}}</td>
                    <td v-if="document.type === 'delete'">{{$t('sandoz.deleted')}}</td>
                    <td v-else>
                      <template v-if="document.status == 'SUCCESS'">
                        <span class="badge badge-success">{{$t('sandoz.contract_found')}}</span>
                      </template>
                      <template v-if="document.status == 'NO_CONTRACT_FOUND'">
                        <span class="badge badge-warning">{{$t('sandoz.contract_not_found')}}</span>
                      </template>
                      <template v-if="document.status == 'CONTRACT_NOT_APPROVED'">
                        <span class="badge badge-danger">{{$t('sandoz.contract_not_approved')}}</span>
                      </template>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </o-card>
</template>

<script>
  export default {
    data: () => ({
      documentList: []
    }),
    methods: {
      documents(doc) {
        this.documentList.unshift(doc)
      }
    }
  }
</script>
